export { setCookie, preventScrolling, lockWindowScroll, unlockWindowScroll, trapFocus, removeTrapFocus, outerHeight, elementInViewport, topOfElementInViewportHeight }

//-----------------------------------------------
// Set Cookie
//-----------------------------------------------

function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

//-----------------------------------------------
// Grid Overlay
//-----------------------------------------------

function initGridOverlay(cols) {
	const body = document.querySelector('body');
	if (body.classList.contains('logged-in') || location.hostname === "localhost") {
		let cells = '';
		for ($i = 0; $i < cols; $i++) {
			cells += '<div class="cell small-1"><div></div></div>';
		}
		const grid = '<div class="grid-container"><div class="grid-x grid-padding-x">' + cells + '</div></div>';
		const gridOverlay = document.createElement('div');
		gridOverlay.classList.add('grid-overlay');
		gridOverlay.innerHTML = grid;
		const button = document.createElement('button');
		button.setAttribute('type', 'button');
		button.classList.add('grid-overlay-button');
		button.innerHTML = '<span class="show-for-sr">Toggle overlay</span>';
		button.addEventListener('click', () => {
			if (gridOverlay.classList.contains('active')) {
				gridOverlay.classList.remove('active');
			} else {
				gridOverlay.classList.add('active');
			}
		}, false);
		body.insertBefore(gridOverlay, body.firstChild);
		body.insertBefore(button, body.firstChild);
	}
}

initGridOverlay(12);

//-----------------------------------------------
// Lock scrolling
//-----------------------------------------------

let currentScrollPosition = window.pageYOffset;

function preventScrolling() {
	window.scrollTo(0, currentScrollPosition);
}

function lockWindowScroll() {
	currentScrollPosition = window.pageYOffset;
	window.addEventListener('scroll', preventScrolling);
}

function unlockWindowScroll() {
	window.removeEventListener('scroll', preventScrolling);
}

//-----------------------------------------------
// Trap Focus
//-----------------------------------------------

// https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
function trapFocus(element) {
	element.classList.add('focus-trap-active');

	const focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	const firstFocusableEl = focusableEls[0];  
	const lastFocusableEl = focusableEls[focusableEls.length - 1];
	const KEYCODE_TAB = 9;

	element.addEventListener('keydown', function(e) {
		const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

		if (!isTabPressed || !element.classList.contains('focus-trap-active')) return

		if (e.shiftKey) /* shift + tab */ {
			if (document.activeElement === firstFocusableEl) {
				lastFocusableEl.focus();
				e.preventDefault();
			}
		} else /* tab */ {
			if (document.activeElement === lastFocusableEl) {
				firstFocusableEl.focus();
				e.preventDefault();
			}
		}
	});
}

function removeTrapFocus(element) {
	element.classList.remove('focus-trap-active');
}

//-----------------------------------------------
// Element Outer Height
//-----------------------------------------------

/**
 * Returns the element height including margins
 * @param element - element
 * @returns {number}
 */
function outerHeight(element) {
	const height = element.offsetHeight,
	style = window.getComputedStyle(element)
	return ['top', 'bottom']
	.map(side => parseInt(style[`margin-${side}`]))
	.reduce((total, side) => total + side, height)
}

//-----------------------------------------------
// Element is in viewport
//-----------------------------------------------

function elementInViewport(el) {
	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

function topOfElementInViewportHeight(el) {
	const rect = el.getBoundingClientRect();
	const vh = (window.innerHeight || document.documentElement.clientHeight);
	return (rect.top >= 0 && rect.top <= vh);
}

//-----------------------------------------------
// JVH javascript height fix
//-----------------------------------------------

function calculateJvh() {
	vh = window.innerHeight * 0.01;
	const vh_val = vh + 'px';
	document.documentElement.style.setProperty('--vh', vh_val);
}

const viewportHeightEls = document.querySelectorAll('.jvh');

if (viewportHeightEls.length > 0) {
	calculateJvh();

	let vhResizeTimer;
	let vw = window.innerWidth;

	window.addEventListener('resize', (e) => {
		clearTimeout(vhResizeTimer);
		let new_vw = window.innerWidth;

		if (new_vw !== vw) {
			vhResizeTimer = setTimeout(() => {
				calculateJvh();
				vw = window.innerWidth;
			}, 10);
		}
	});
}

//-----------------------------------------------
// Touch Check
//-----------------------------------------------

function is_touch_enabled() {
    return ( 'ontouchstart' in window ) ||
           ( navigator.maxTouchPoints > 0 ) ||
           ( navigator.msMaxTouchPoints > 0 );
}

function addTouchSupportClass() {
	if (is_touch_enabled()) {
		const body = document.querySelector('body');
		body.classList.add('touch');
	}
}

addTouchSupportClass();